import { FieldConfig } from "../Components/Form/FormComponent/types";

export const courseListingFields: FieldConfig[] = [
  {
    label: "Course Name",
    name: "courseName",
    type: "text",
    required: true,
  },
  {
    label: "University Name",
    name: "universityName",
    type: "select",
    options: [],
    required: true,
  },
  {
    label: "Country",
    name: "country",
    type: "select",
    options: [
      "Malaysia",
      "Singapore",
      "United Kingdom",
      "China",
      "Australia",
      "Ireland",
      "United States",
      "South Korea",
      "Switzerland",
    ],
    required: true,
  },
  {
    label: "State",
    name: "state",
    type: "select",
    dependsOn: "country",
    options: [],
    required: true,
  },
  {
    label: "Course Duration",
    name: "duration",
    type: "number",
    required: true,
    max: 7,
    min: 0,
    placeholder: "Years",
  },
  {
    label: "Intake",
    name: "intake",
    type: "tags",
    options: [
      "JAN",
      "FEB",
      "MAR",
      "APR",
      "MAY",
      "JUN",
      "JUL",
      "AUG",
      "SEPT",
      "OCT",
      "NOV",
      "DEC",
    ],
    required: true,
    allowTagEdit: false,
  },
  {
    label: "Field of Study",
    name: "fieldOfStudy",
    type: "select",
    options: [
      "Accounting and Finance",
      "Architecture and Built Environment",
      "Business",
      "Communication and Media Studies",
      "Computing and IT",
      "Creative Arts and Design",
      "Education",
      "Engineering",
      "Foundation",
      "Hospitality and Services",
      "International Pre-University",
      "Language and Social Studies",
      "Law",
      "Medicine and Allied Health Sciences",
      "Science and Mathematics",
    ],
    required: true,
  },
  {
    label: "Major",
    name: "major",
    type: "select",
    dependsOn: "fieldOfStudy",
    options: [],
    required: true,
  },
  {
    label: "Level",
    name: "level",
    type: "select",
    options: [
      "Advanced Diploma",
      "Certificate",
      "Degree",
      "Diploma",
      "Foundation/Pre-U",
      "Postgraduate - Diploma",
      "Postgraduate - Masters",
      "Postgraduate - PhD",
      "Professional Programmes",
    ],
    required: true,
  },
  {
    label: "Tuition Fee",
    name: "tuitionFee",
    type: "number",
    placeholder: "MYR",
    required: true,
    max: 1000000,
    min: 0,
  },
  {
    label: "Registration Fee",
    name: "registrationFee",
    type: "number",
    placeholder: "MYR",
    min: 0,
    max: 100000,
  },
  {
    label: "Resource Fee",
    name: "resourceFee",
    type: "number",
    placeholder: "MYR",
    min: 0,
    max: 100000,
  },
  {
    label: "Extra Fees",
    name: "extraFees",
    type: "objectList",
    objectFields: [
      { key: "title", label: "Fees Name", type: "text" },
      { key: "amount", label: "Amount (MYR)", type: "number" },
    ],
  },
  {
    label: "Deals",
    name: "deals",
    type: "objectList",
    objectFields: [
      { key: "title", label: "Deals Title", type: "text" },
      { key: "amount", label: "Amount (MYR)", type: "number" },
    ],
  },
  {
    label: "Scholarships",
    name: "scholarships",
    type: "objectList",
    required: false,
    objectFields: [
      { key: "title", label: "Scholarship Title", type: "text" },
      { key: "amount", label: "Amount (MYR)", type: "number" },
    ],
  },
  {
    label: "Payment Schemes",
    name: "paymentSchemes",
    type: "select",
    options: ["Monthly", "Bi Monthly", "Semester", "Annual"],
    required: true,
  },
  {
    label: "Part Time Option",
    name: "partTimeOption",
    type: "select",
    options: ["Yes", "No"],
    required: true,
  },

  {
    label: "Overseas Transfer",
    name: "overseasTransfer",
    type: "select",
    options: [
      "None",
      "Australia",
      "Canada",
      "France",
      "United Kingdom",
      "United States",
    ],
    required: true,
  },
  {
    label: "Abroad Duration",
    name: "abroadDuration",
    type: "number",
    placeholder: "Years",
    required: true,
    max: 5,
    min: 0,
  },
  {
    label: "Entry Requirements",
    name: "entryRequirements",
    type: "objectList",
    objectFields: [
      {
        key: "qualification",
        label: "Qualifications",
        type: "select",
        options: [
          "A-level",
          "UEC",
          "Diploma",
          "STPM",
          "Foundation",
          "CPU",
          "IB Diploma",
          "AUSMAT",
        ],
      },
      { key: "grade", label: "Grade", type: "text" },
      { key: "details", label: "Details", type: "text" },
    ],
  },
  { label: "Entry Details", name: "entryDetails", type: "tags" },
  {
    label: "Interview",
    name: "interview",
    type: "select",
    options: ["Yes", "No"],
  },
  {
    label: "English Requirements",
    name: "englishRequirements",
    type: "objectList",
    objectFields: [
      {
        key: "title",
        label: "Title",
        type: "select",
        options: ["IELTS", "MUET", "TOEFL", "Others"],
      },
      { key: "details", label: "Details", type: "text" },
    ],
  },
  // {
  //   label: "Course Syllabus",
  //   name: "courseSyllabus",
  //   type: "objectList",
  //   objectFields: [
  //     { key: "title", label: "title", type: "text" },
  //     { key: "details", label: "details", type: "text" },
  //   ],
  // },
];

export const majorOptions: Record<string, string[]> = {
  "Accounting and Finance": [
    "ACCA",
    "ACCA Foundation in Accountancy (ACCA FiA)",
    "Accounting",
    "Accounting and Finance",
    "Audit",
    "Banking",
    "Banking and Finance",
    "CFAB",
    "CIMA",
    "Economics",
    "Economics and Finance",
    "Entrepreneurship",
    "Finance",
    "Financial Technology",
    "Forensic Accounting",
    "ICAEW",
    "Investment",
    "Islamic Finance",
    "Law",
    "Management",
    "Professional Accounting",
    "Taxation",
  ],
  "Architecture and Built Environment": [
    "Architecture",
    "Construction Management",
    "Interior Architecture",
    "Interior Design",
    "Landscape Architecture",
    "Quantity Surveying",
    "Urban Planning",
  ],
  Business: [
    "Accounting",
    "Actuarial Science",
    "Advertising",
    "Banking",
    "Business Administration",
    "Business Information",
    "Business and Management",
    "Communication",
    "Construction Management",
    "Data Science Management",
    "Digital Business",
    "Digital Health",
    "Digital Marketing",
    "E-commerce",
    "Economics",
    "Enterprise",
    "Entrepreneurship",
    "Finance",
    "Healthcare Management",
    "Human Resource Management",
    "International Business",
    "Investment",
    "Law",
    "Logistic and Supply Chain Management",
    "MBA Programme",
    "Management",
    "Marketing",
    "Project Management",
    "Property and Real Estate",
    "Psychology",
    "Public Relations",
    "Retail Management",
    "Sijil Kemahiran Malaysia (SKM)",
    "Sports Management",
    "Technopreneurship",
  ],
  "Communication and Media Studies": [
    "Advertising",
    "Animation",
    "Branding",
    "Broadcasting",
    "Communication",
    "Creative Arts",
    "Design",
    "Digital Media",
    "Event Management",
    "Film and Television",
    "Games Development",
    "Graphic Design",
    "Journalism",
    "Management",
    "Marketing",
    "Mass Communication",
    "Media Studies",
    "Multimedia Design",
    "Photography",
    "Professional Communication",
    "Psychology",
    "Public Relations",
    "UI Design",
    "Virtual Reality",
    "Visual Effects",
  ],
  "Computing and IT": [
    "Analytics",
    "Artificial Intelligence",
    "Business Information",
    "Cloud Computing",
    "Communication Technology",
    "Computer Science",
    "Cybersecurity",
    "Data Science",
    "Database Administration",
    "E-commerce",
    "Entrepreneurship",
    "Forensic Computing",
    "Games Development",
    "Information Security",
    "Information Systems",
    "Information Technology (IT)",
    "Intelligent Systems",
    "Internet Technology",
    "Internet of Things (IoT)",
    "Mathematics",
    "Mobile Computing",
    "Multimedia Design",
    "Network Technology",
    "Sijil Kemahiran Malaysia (SKM)",
    "Software Development",
    "Software Engineering",
  ],
  "Creative Arts and Design": [
    "Animation",
    "Classical Music",
    "Contemporary Art",
    "Contemporary Music",
    "Creative Arts",
    "Digital Media",
    "Fashion Design",
    "Fine Art",
    "Graphic Design",
    "Illustration",
    "Industrial Design",
    "Make-Up and Hair Design",
    "Music",
    "Packaging",
    "Performing Arts",
    "Transportation",
    "Visual Art",
  ],
  Education: [
    "Chinese",
    "Counselling",
    "Early Childhood Education",
    "Education",
    "English (Teaching)",
    "Healthcare",
    "Sijil Kemahiran Malaysia (SKM)",
    "Special Needs Education",
    "Teaching",
  ],
  Engineering: [
    "Aeronautical Engineering",
    "Aircraft Maintenance Engineering",
    "Automotive Engineering",
    "Automotive Technology",
    "Biomedical Engineering",
    "Chemical Engineering",
    "Civil Engineering",
    "Computer Systems Engineering",
    "Electrical and Electronic Engineering",
    "Electrical Engineering",
    "Electronic Engineering",
    "Environmental Engineering",
    "General Engineering and Technology",
    "Geomatic Engineering",
    "Industrial Design",
    "Industrial Engineering",
    "Management",
    "Manufacturing Engineering",
    "Manufacturing and Production",
    "Marine Engineering",
    "Material Engineering",
    "Mechanical Engineering",
    "Mechatronics Engineering",
    "Microelectronics Design",
    "Nanotechnology",
    "Oil and Gas Operations",
    "Optical Engineering",
    "Petrochemical",
    "Petroleum Engineering",
    "Renewable Energy Engineering",
    "Robotics Engineering",
    "Sijil Kemahiran Malaysia (SKM)",
    "Telecommunications",
  ],
  Foundation: ["Foundation in Arts", "Foundation in Science"],
  "Hospitality and Services": [
    "Airline Services",
    "Culinary Arts",
    "Culinology",
    "Event Management",
    "F&B Preparation and Production",
    "Hospitality Management",
    "Hospitality and Tourism Management",
    "Hotel Management",
    "Marketing",
    "Patisserie & Gastronomic Cuisine",
    "Restaurant Management",
    "Sijil Kemahiran Malaysia (SKM)",
    "Tourism Management",
  ],
  "International Pre-University": [
    "Western Australian Certificate of Education Board (WACE)",
    "A-Levels",
    "American Degree Transfer Programme",
    "Australian Degree Transfer Programme",
    "Australian Matriculation (AUSMAT)",
    "Canadian Matriculation",
    "International Baccalaureate (IB Diploma)",
    "International Baccalaureate (IB)",
    "Monash University Foundation Year (MUFY)",
    "South Australian Certificate of Education (SACE)",
    "Transition Program",
  ],
  "Language and Social Studies": [
    "Chinese Studies",
    "Cognitive Neuroscience",
    "Communication",
    "Counselling",
    "Economics",
    "English",
    "Gender Studies",
    "IELTS",
    "International Relations",
    "Language Studies",
    "Literature",
    "Malay Studies",
    "Management",
    "Philosophy",
    "Police Science",
    "Policy Science",
    "Politics",
    "Psychology",
    "Public Relations",
    "Social Sciences",
    "Translation Studies",
    "Writing",
  ],
  Law: [
    "Business Law",
    "Certificate in Legal Practice (CLP)",
    "Commercial Law",
    "Construction Law",
    "Employment Law",
    "Government and Politics Law",
    "Healthcare Law",
    "Insurance Law",
    "Intellectual Law",
    "International Law",
    "Labour Law",
    "Law (LL.B.)",
    "Oil and Gas Law",
    "UK Law Degree Transfer Programme",
  ],
  "Medicine and Allied Health Sciences": [
    "Acupuncture",
    "Alternative Medicine",
    "Anatomy",
    "Biomedical Science",
    "Chiropractic",
    "Critical Care",
    "Dentistry",
    "Dietetics",
    "Forensic Science",
    "Health Informatics",
    "Health Studies",
    "Healthcare",
    "Management",
    "Medical Sciences",
    "Medical Technology",
    "Medicine",
    "Midwifery",
    "Nursing",
    "Nutrition",
    "Occupational Safety and Health",
    "Occupational Therapy",
    "Oncology",
    "Paediatrics",
    "Paramedic Science",
    "Perioperative Care",
    "Pharmaceutical Chemistry",
    "Pharmaceutical Science",
    "Pharmacy",
    "Physiotherapy",
    "Public Health",
    "Renal Nursing",
    "Sports Science",
    "Surgery",
    "Traditional Chinese Medicine",
    "Veterinary Medicine",
  ],
  "Science and Mathematics": [
    "Agriculture",
    "Aquaculture",
    "Aquatic Science",
    "Biochemistry",
    "Bioinformatics",
    "Biology",
    "Biotechnology",
    "Chemistry",
    "Computing",
    "Economics",
    "Environmental Health",
    "Environmental Sciences",
    "Financial Mathematics",
    "Food Science",
    "General Sciences (Oversea)",
    "General Sciences (Postgraduate)",
    "Geography",
    "Geology",
    "Management",
    "Mathematics",
    "Microbiology",
    "Nautical Science",
    "Physics",
    "Psychology",
  ],
};

export const stateOptions: Record<string, string[]> = {
  Malaysia: [
    "Johor",
    "Kedah",
    "Kelantan",
    "Melaka",
    "Negeri Sembilan",
    "Pahang",
    "Pulau Pinang",
    "Perak",
    "Perlis",
    "Selangor",
    "Terengganu",
    "Sabah",
    "Sarawak",
    "Kuala Lumpur",
    "Labuan",
    "Putrajaya",
  ],
  Singapore: [
    "Central",
    "North East",
    "North West",
    "South East",
    "South West",
  ],
  "United Kingdom": [
    "Aberdeenshire",
    "Aberdeen City",
    "Argyll and Bute",
    "Isle of Anglesey",

    "Angus",
    "Antrim",
    "Ards",
    "Armagh",
    "Bath and North East Somerset",
    "Blackburn with Darwen",
    "Bedfordshire",
    "Barking and Dagenham",
    "Brent",
    "Bexley",
    "Belfast",
    "Bridgend",
    "Blaenau Gwent",
    "Birmingham",
    "Buckinghamshire",
    "Ballymena",
    "Ballymoney",
    "Bournemouth",
    "Banbridge",
    "Barnet",
    "Brighton and Hove",
    "Barnsley",
    "Bolton",
    "Blackpool",
    "Bracknell Forest",
    "Bradford",
    "Bromley",
    "Bristol City",
    "Bury",
    "Cambridgeshire",
    "Caerphilly",
    "Ceredigion",
    "Craigavon",
    "Cheshire",
    "Carrickfergus",
    "Cookstown",
    "Calderdale",
    "Clackmannanshire",
    "Coleraine",
    "Cumbria",
    "Camden",
    "Carmarthenshire",
    "Cornwall",
    "Coventry",
    "Cardiff",
    "Croydon",
    "Castlereagh",
    "Conwy",
    "Darlington",
    "Derbyshire",
    "Denbighshire",
    "Derby",
    "Devon",
    "Dungannon",
    "Dumfries and Galloway",
    "Doncaster",
    "Dundee City",
    "Dorset",
    "Down",
    "Derry",
    "Dudley",
    "Durham",
    "Ealing",
    "East Ayrshire",
    "Edinburgh City",
    "East Dunbartonshire",
    "East Lothian",
    "Eilean Siar",
    "Enfield",
    "East Renfrewshire",
    "East Riding of Yorkshire",
    "Essex",
    "East Sussex",
    "Falkirk",
    "Fermanagh",
    "Fife",
    "Flintshire",
    "Gateshead",
    "Glasgow City",
    "Gloucestershire",
    "Greenwich",
    "Gwynedd",
    "Halton",
    "Hampshire",
    "Havering",
    "Hackney",
    "Herefordshire",
    "Hillingdon",
    "Hammersmith and Fulham",
    "Hounslow",
    "Hartlepool",
    "Hertfordshire",
    "Harrow",
    "Haringey",
    "Isles of Scilly",
    "Isle of Wight",
    "Islington",
    "Inverclyde",
    "Kensington and Chelsea",
    "Kent",
    "Kingston upon Hull City",
    "Kirklees",
    "Kingston upon Thames",
    "Knowsley",
    "Lancashire",
    "Lambeth",
    "Leicester",
    "Leeds",
    "Leicestershire",
    "Lewisham",
    "Lincolnshire",
    "Liverpool",
    "Limavady",
    "London City",
    "Larne",
    "Lisburn",
    "Luton",
    "Manchester",
    "Middlesbrough",
    "Medway",
    "Magherafelt",
    "Milton Keynes",
    "Midlothian",
    "Monmouthshire",
    "Merton",
    "Moray",
    "Merthyr Tydfil",
    "Moyle",
    "North Ayrshire",
    "Northumberland",
    "North Down",
    "North East Lincolnshire",
    "Newcastle upon Tyne",
    "Norfolk",
    "Nottingham",
    "North Lanarkshire",
    "North Lincolnshire",
    "North Somerset",
    "Newtownabbey",
    "Northamptonshire",
  ],
  China: [
    "Beijing",
    "Shanghai",
    "Guangdong",
    "Jiangsu",
    "Zhejiang",
    "Shandong",
    "Henan",
    "Sichuan",
    "Hubei",
    "Hunan",
  ],
  Australia: [
    "New South Wales",
    "Victoria",
    "Queensland",
    "Western Australia",
    "South Australia",
    "Tasmania",
    "Australian Capital Territory",
    "Northern Territory",
  ],
  Ireland: ["Connacht", "Leinster", "Munster", "Ulster"],
  "United States": [
    "Alabama",
    "Alaska",
    "Arizona",
    "Arkansas",
    "California",
    "Colorado",
    "Connecticut",
    "Delaware",
    "Florida",
    "Georgia",
    "Hawaii",
    "Idaho",
    "Illinois",
    "Indiana",
    "Iowa",
    "Kansas",
    "Kentucky",
    "Louisiana",
    "Maine",
    "Maryland",
    "Massachusetts",
    "Michigan",
    "Minnesota",
    "Mississippi",
    "Missouri",
    "Montana",
    "Nebraska",
    "Nevada",
    "New Hampshire",
    "New Jersey",
    "New Mexico",
    "New York",
    "North Carolina",
    "North Dakota",
    "Ohio",
    "Oklahoma",
    "Oregon",
    "Pennsylvania",
    "Rhode Island",
    "South Carolina",
    "South Dakota",
    "Tennessee",
    "Texas",
    "Utah",
    "Vermont",
    "Virginia",
    "Washington",
    "West Virginia",
    "Wisconsin",
    "Wyoming",
  ],
  "South Korea": [
    "Seoul",
    "Busan",
    "Incheon",
    "Daegu",
    "Daejeon",
    "Gwangju",
    "Suwon",
    "Ulsan",
    "Sejong",
    "Gyeonggi",
    "Gangwon",
    "Chungcheongbuk",
    "Chungcheongnam",
    "Jeollabuk",
    "Jeollanam",
    "Gyeongsangbuk",
    "Gyeongsangnam",
    "Jeju",
  ],
  Switzerland: [
    "Aargau",
    "Appenzell Innerrhoden",
    "Appenzell Ausserrhoden",
    "Basel-Landschaft",
    "Basel-Stadt",
    "Bern",
    "Fribourg",
    "Genève",
    "Glarus",
    "Graubünden",
    "Jura",
    "Luzern",
    "Neuchâtel",
    "Nidwalden",
    "Obwalden",
    "Sankt Gallen",
    "Schaffhausen",
    "Solothurn",
    "Schwyz",
    "Thurgau",
    "Ticino",
    "Uri",
    "Valais",
    "Vaud",
    "Zug",
    "Zürich",
  ],
};
